import type { WeekHours, DayHours } from '@skytech/shared';

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0]; // Mon → Sun for display

const fmtDay = (h: DayHours | null | undefined): string =>
  h ? `${h.open} – ${h.close}` : 'Closed';

/** Collapse consecutive same-hours days into rows, e.g. "Mon–Fri: 8:00 – 18:00". */
export function groupHours(
  hours: WeekHours,
): Array<{ label: string; value: string; days: number[] }> {
  const rows: Array<{ label: string; value: string; days: number[] }> = [];
  for (let i = 0; i < WEEK_ORDER.length;) {
    const sig = fmtDay(hours[String(WEEK_ORDER[i]) as keyof WeekHours]);
    let j = i;
    while (
      j + 1 < WEEK_ORDER.length &&
      fmtDay(hours[String(WEEK_ORDER[j + 1]) as keyof WeekHours]) === sig
    )
      j++;
    const label =
      i === j
        ? DAY_NAMES[WEEK_ORDER[i]!]!
        : `${DAY_NAMES[WEEK_ORDER[i]!]}–${DAY_NAMES[WEEK_ORDER[j]!]}`;
    rows.push({ label, value: sig, days: WEEK_ORDER.slice(i, j + 1) });
    i = j + 1;
  }
  return rows;
}
